import { STORAGE_KEY } from '@/constant/constant';
import { getSession, setSession } from '@/utils/storage';

/**
 * 方法实现里，需要把能读到的参数都读出来，上报就要上报全面，有利于分析数据
 * @param params 上报的参数
 */
const logToServer = (params) => {
  let data = Object.assign({ date: Date.now() }, params);
  // 添加浏览器参数
  data = Object.assign(data, readBrowserParams());
  if (process.env.NODE_ENV !== 'production') {
    console.log('开发环境，不上报bug，打印在控制台：', JSON.parse(JSON.stringify(data)));
  }
  // 表单
  const fd = new FormData();
  if (data['site']) {
    fd.append('site', data['site']);
    delete data.site;
  }
  if (data['ru']) {
    fd.append('requestUrl', data['ru']);
    delete data.ru;
  }
  if (data['em']) {
    fd.append('reason', data['em']);
    delete data.em;
  }
  if (data['type']) {
    fd.append('type', data['type']);
    delete data.type;
  }
  if (data['time']) {
    fd.append('time', data['time']);
    delete data.time;
  }
  fd.append('param', JSON.stringify(data));

  if (process.env.NODE_ENV === 'production') {
    // 只有生产环境上报，开发环境不上报
    if (navigator?.sendBeacon) {
      navigator.sendBeacon('https://cartsee-form-c.cartx.cloud/cartsee/form/monitor/request', fd);
    } else {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://cartsee-form-c.cartx.cloud/cartsee/form/monitor/request');
      xhr.send(fd);
    }
  }
};

/**
 * 读取浏览器参数
 * @returns 浏览器参数
 */
const readBrowserParams = () => {
  return {
    site: window.location.href,
    ua: window.navigator?.userAgent
  };
};

/**
 * 上报js报错
 * @param error js错误信息
 */
const LogJsError = (error) => {
  // 格式化报错
  let data = {
    type: 'POP-JSERROR',
    error: null
  };
  if (typeof error != 'object') {
    data.error = `${error}`;
  } else {
    data = Object.assign({ type: 'POP-JSERROR' }, error);
  }
  // 进行上报
  logToServer(data);
};

/**
 * 上报500的错误
 * @param error 错误信息，需要给出url信息
 */
const Log500Error = (error) => {
  // 格式化报错
  let data = {
    type: 'POP-500ERROR',
    error: null
  };
  if (typeof error != 'object') {
    data.error = `${error}`;
  } else {
    data = Object.assign({ type: 'POP-500ERROR' }, error);
  }
  // 进行上报
  logToServer(data);
};

/**
 * 上报接口耗时
 * @param error
 */
const LogApiTime = (error) => {
  // 格式化报错
  let data = {
    type: 'POP-APITIME',
    error: null
  };
  if (typeof error != 'object') {
    data.error = `${error}`;
  } else {
    data = Object.assign({ type: 'POP-APITIME' }, error);
  }
  // 进行上报
  logToServer(data);
};

const LogTimeoutError = (error) => {
  // 格式化报错
  let data = {
    type: 'POP-TIMEOUTERROR',
    error: null
  };
  if (typeof error != 'object') {
    data.error = `${error}`;
  } else {
    data = Object.assign({ type: 'POP-TIMEOUTERROR' }, error);
  }
  // 进行上报
  logToServer(data);
};

const logPageLoading = () => {
  const {
    redirectEnd,
    redirectStart,
    fetchStart,
    connectStart,
    connectEnd,
    requestStart,
    responseStart,
    responseEnd,
    domLoading,
    domInteractive,
    domComplete,
    domContentLoadedEventStart,
    domContentLoadedEventEnd,
    loadEventStart,
    loadEventEnd,
    navigationStart,
    domainLookupEnd,
    domainLookupStart
  } = window.performance?.toJSON()?.timing || window.performance?.timing;
  // console.log(JSON.stringify(performance.toJSON().timing));
  const old = getSession(STORAGE_KEY.PAGE_LOAD);
  if (old) {
    if (navigationStart != old) {
      setSession(STORAGE_KEY.PAGE_LOAD, navigationStart);
    } else {
      return;
    }
  } else {
    setSession(STORAGE_KEY.PAGE_LOAD, navigationStart);
  }
  // 重定向时间
  const redirectDuration = redirectEnd - redirectStart;
  // DNS查询耗时
  const dnsDuration = domainLookupEnd - domainLookupStart;
  // TCP链接耗时
  const tcpDuration = connectEnd - connectStart;
  // request耗时
  const requestDuration = responseEnd - requestStart;
  // 解析dom树耗时
  const domParseDuration = domComplete - domInteractive;
  // 白屏时间
  const whiteScreenDuration = domLoading - fetchStart;
  // onload时间（页面加载的大概时间，因为重定向时间和worker时间有时候为0统计不到）
  const onloadDuration = loadEventEnd == 0 ? loadEventStart - fetchStart + 1 : loadEventEnd - fetchStart;
  if (process.env.NODE_ENV !== 'production') {
    console.log('重定向时间', redirectDuration);
    console.log('DNS查询耗时', dnsDuration);
    console.log('TCP链接耗时', tcpDuration);
    console.log('request耗时', requestDuration);
    console.log('解析dom树耗时', domParseDuration);
    console.log('白屏时间', whiteScreenDuration);
    console.log('onload时间', onloadDuration);
  }
  logToServer({
    type: 'pageload',
    pp: {
      redirect: redirectDuration,
      dns: dnsDuration,
      tcp: tcpDuration,
      req: requestDuration,
      domParse: domParseDuration,
      whiteScreen: whiteScreenDuration,
      onload: onloadDuration
    },
    time: onloadDuration
  });
};

export { Log500Error, LogJsError, LogTimeoutError, LogApiTime, logPageLoading };
